import type {
  SyncParticipantsRequest,
  SyncParticipantsValidator,
} from '@usecases/sync-participants.usecase';
import { Logger } from '@main/utils/logger';

export class SyncParticipantsValidatorImpl
  implements SyncParticipantsValidator
{
  private logger: Logger;

  constructor() {
    this.logger = new Logger();
  }

  async validate(
    req: SyncParticipantsRequest,
  ): Promise<Partial<Record<keyof SyncParticipantsRequest, string>> | void> {
    this.logger.info('SyncParticipantsValidator: Validating request', {
      action: 'ValidateSyncParticipants',
      request: req,
    });

    const errors: Partial<Record<keyof SyncParticipantsRequest, string>> = {};

    if (!req.callId) {
      errors.callId = 'Call Id is required';
    }

    if (!req.activeParticipant && !req.me) {
      errors.activeParticipant = 'At least one participant is required';
    }

    if (req.activeParticipant) {
      if (!req.activeParticipant.legId) {
        errors.activeParticipant = 'Leg ID is required';
      }

      if (!req.activeParticipant.state) {
        errors.activeParticipant = 'State is required';
      }
    }

    if (req.me) {
      if (!req.me.legId) {
        errors.me = 'Leg ID is required';
      }

      if (!req.me.state) {
        errors.me = 'State is required';
      }
    }

    if (Object.keys(errors).length > 0) {
      this.logger.error('SyncParticipantsValidator: Validation failed', {
        action: 'ValidateSyncParticipants',
        errors,
        request: req,
      });
    } else {
      this.logger.info('SyncParticipantsValidator: Validation successful', {
        action: 'ValidateSyncParticipants',
        request: req,
      });
    }

    return Object.keys(errors).length > 0 ? errors : undefined;
  }
}
